module.exports = __webpack_public_path__ + "img/trail-button.155bd283.svg";